module.exports = __webpack_public_path__ + "static/d5-59a1d6eac8214cf412373f225d08c6e5.jpg";